/**
 * Determines if the given URL string is an absolute URL.
 */
export function isAbsoluteUrl(url: string): boolean {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
}
